import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	DataBoxConfirmModalType,
	DataBoxListStatesType,
	useDataBoxMessageListContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Icon } from '@gov-nx/ui/web';
import { limitNumber } from '@gov-nx/utils/common';

export const DataBoxMessageListFooter = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const {
		listState,
		messagesSelect: { selectedMessageList },
		massOperations,
		setConfirmModal,
		loadingItems,
	} = useDataBoxMessageListContext();

	return (
		<footer className="px-4 py-6 bg-(--background-primary-subtle) text-center">
			{[
				DataBoxListStatesType.MassArchive,
				DataBoxListStatesType.SearchMassArchive,
			].includes(listState) && (
				<Button
					color="primary"
					type="outlined"
					size="m"
					isExpanded
					isLoading={loadingItems.archive}
					onClick={massOperations.handleArchiveMessages}
					isDisabled={!selectedMessageList.length || !!loadingItems.archive}
					aria-label={
						tn('zpravy.zkopirovat-do-archivu') +
						' ' +
						(!!selectedMessageList.length && (
							<>({limitNumber(selectedMessageList.length)})</>
						))
					}
					iconStart={
						!loadingItems.archive && (
							<Icon
								name="archived-outline"
								type="templates"
							/>
						)
					}>
					{tn('zpravy.zkopirovat-do-archivu')}{' '}
					{!!selectedMessageList.length && (
						<>({limitNumber(selectedMessageList.length)})</>
					)}
				</Button>
			)}
			{[
				DataBoxListStatesType.MassRemove,
				DataBoxListStatesType.SearchMassRemove,
			].includes(listState) && (
				<Button
					color="error"
					type="outlined"
					size="m"
					isExpanded
					onClick={() =>
						setConfirmModal(DataBoxConfirmModalType.removeMessages)
					}
					isDisabled={!selectedMessageList.length}
					aria-label={
						tn('zpravy.vypis.presunout-do-kose') +
						' ' +
						(!!selectedMessageList.length && (
							<>({limitNumber(selectedMessageList.length)})</>
						))
					}
					iconStart={
						<Icon
							name="trash"
							type="templates"
						/>
					}>
					{tn('zpravy.vypis.presunout-do-kose')}{' '}
					{!!selectedMessageList.length && (
						<>({limitNumber(selectedMessageList.length)})</>
					)}
				</Button>
			)}
			{[
				DataBoxListStatesType.MassPermanentRemove,
				DataBoxListStatesType.SearchMassPermanentRemove,
			].includes(listState) && (
				<Button
					color="error"
					type="outlined"
					size="m"
					isExpanded
					onClick={() =>
						setConfirmModal(DataBoxConfirmModalType.removeMessagesPermanently)
					}
					isDisabled={!selectedMessageList.length}
					aria-label={
						tn('zpravy.trvale-smazat') +
						' ' +
						(!!selectedMessageList.length && (
							<>({limitNumber(selectedMessageList.length)})</>
						))
					}
					iconStart={
						<Icon
							name="trash"
							type="templates"
						/>
					}>
					{tn('zpravy.trvale-smazat')}{' '}
					{!!selectedMessageList.length && (
						<>({limitNumber(selectedMessageList.length)})</>
					)}
				</Button>
			)}
			{[
				DataBoxListStatesType.MassRestore,
				DataBoxListStatesType.SearchMassRestore,
			].includes(listState) && (
				<Button
					color="primary"
					type="outlined"
					size="m"
					isExpanded
					isLoading={loadingItems.restore}
					onClick={massOperations.handleRestoreMessages}
					isDisabled={!selectedMessageList.length || !!loadingItems.restore}
					aria-label={
						tn('zpravy.obnovit') +
						(!!selectedMessageList.length && (
							<>({limitNumber(selectedMessageList.length)})</>
						))
					}
					iconStart={
						!loadingItems.restore && (
							<Icon
								name="arrow-counterclockwise"
								type="templates"
							/>
						)
					}>
					{tn('zpravy.obnovit')}{' '}
					{!!selectedMessageList.length && (
						<>({limitNumber(selectedMessageList.length)})</>
					)}
				</Button>
			)}
		</footer>
	);
};
